import qs from 'qs-lite';

export const getQueryParamMap = (history) => {
  const search = history?.location?.search?.split('?')?.[1];
  return search ? qs.parse(search) : {};
};

export const updateQueryString = (history, newQueryParams) => {
  const queryParamMap = {
    ...getQueryParamMap(history),
    ...newQueryParams
  };
  const searchString = `?${qs.stringify(queryParamMap)}`;
  history?.push({
    pathname: history?.location?.pathname,
    search: searchString
  });
};



// WEBPACK FOOTER //
// ./src/utils/query-params.js